import React from 'react';
import PerSurfCompareParagraphList from './PerSurfCompareParagraphList';
import webapi from '../../../api/webapi';
import EmptyDiv from '../Footer/EmptyDIV';
import Loading from '../modal/Loading';

class PerSurfVersionCompareSelectBar extends React.Component{
    
    state = { item: '' };
    state = { item1: '' };
    state = { item2: '' };
    state = { modalshow: false };

    componentDidMount() {
        this.setState({ item : '' });   
        this.setState({ item1 : '' });   
        this.setState({ item2 : '' });   
    }

    async GetData() {
        this.setState({loadingShow:true})
        //console.log('persiansurf/paragraph/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.item)
        await webapi.get('persiansurf/paragraph/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.item)
            .then(response => {
                this.setState({ ParagraphList : response.data },()=>{});
            }) 
        this.setState({loadingShow:false})
    }

    async GetDataCompare() {
        this.setState({loadingShow:true})
        //console.log('persiansurf/paragraph/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.item)
        await webapi.get('persiansurf/compare/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.item1+'/'+this.state.item2)
            .then(response => {
                this.setState({ ParagraphList : response.data },()=>{});
                //console.log(response.data);
            }) 
        this.setState({loadingShow:false})
    }

    async UpdateParagraphSequenceList(){
        this.setState({loadingShow:true})
        this.setState({ ParagraphList : '' })
        await webapi.get('persiansurf/bookversionbook/'+this.state.SelectedBook)
            .then(response => {
                this.setState({ ParagraphSequenceList: response.data},()=>{});
            })
        //if  (this.state.ParagraphSequenceList.length===1)
        //{   
            this.setState({ item : this.state.ParagraphSequenceList[0].Code })
            this.setState({ item1 : this.state.ParagraphSequenceList[0].Code })
            this.setState({ item2 : this.state.ParagraphSequenceList[0].Code })
        // }
        // else
        //     if  (this.state.ParagraphSequenceList.length>1)
        //     {
        //         this.setState({ item : 'All' })
        //     }
        this.setState({loadingShow:false})
    }

    componentDidUpdate() {
        if ((this.props.SelectedBook)&&(this.props.SelectedChapter)&&(this.props.SelectedChapter!==this.state.SelectedChapter))
        {
            this.setState({ SelectedBook : this.props.SelectedBook },()=>{});
            this.setState({ SelectedChapter : this.props.SelectedChapter },()=>{this.UpdateParagraphSequenceList();});
        }
     }
     
    onSearchButtonClick = event =>{
        event.preventDefault();
        this.setState({ ParagraphList : '' })
        this.GetData(); 
    }

    

    onTextChange = event=> {
        this.setState({ item : event.target.value });
        this.setState({ ParagraphList : '' })
    }

    onTextKeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.Item)) {
            event.preventDefault();
            this.onSearchButtonClick(event);
        }
    }

    onCompareButtonClick = event =>{
        event.preventDefault();
        this.setState({ ParagraphList : '' })
        this.GetDataCompare(); 
    }

    onText1Change = event=> {
        this.setState({ item1 : event.target.value });
        this.setState({ ParagraphList : '' })
    }

    onText1KeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.Item1)) {
            event.preventDefault();
            this.onCompareButtonClick(event);
        }
    }

    onText2Change = event=> {
        this.setState({ item2 : event.target.value });
        this.setState({ ParagraphList : '' })
    }

    onText2KeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.Item2)) {
            event.preventDefault();
            this.onCompareButtonClick(event);
        }
    }

    render(){
        return (
            [
                <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}}>
                    <form>
                        <div className="divSearchCompare">
                            <div className="fullwidth_div">
                                {/*<label style={{width:'calc(50% - 30px)',margin:'0px',marginRight: '25%',marginTop: '15px', float: 'right'}}>{this.props.Label}</label>*/}
                                <select 
                                    id="item1" 
                                    type="text" 
                                    className="Select_Compare"
                                    required="required" 
                                    value={this.state.item1 || ''} 
                                    onChange={this.onText1Change}
                                    onKeyPress={this.onText1KeyPress}
                                >  
                                    {   
                                        ((this.state.ParagraphSequenceList)&&(this.state.ParagraphSequenceList != null))
                                        ?
                                        (this.state.ParagraphSequenceList.map((ParagraphSequence,i) =>
                                            {
                                                return  (
                                                    (i===0)
                                                    ?
                                                    (
                                                        //[
                                                          //  <option key={ParagraphSequence.Code+"-1"} value={"All"} select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F89902!== undefined?this.props.pageData[0].F89902:89902/*همه*/}</option>
                                                            //,
                                                            <option key={ParagraphSequence.Code} value={ParagraphSequence.Code}>{ParagraphSequence.Title}</option> 
                                                        //]
                                                    )
                                                    :
                                                    (
                                                        <option key={ParagraphSequence.Code} value={ParagraphSequence.Code}>{ParagraphSequence.Title}</option> 
                                                    )
                                                )
                                            })
                                        )
                                        :
                                        <option value="-1">-</option>       
                                    }                
                                </select>
                                
                                <input className="submit_button" type="submit" value={this.props.pageData.length!==0 && this.props.pageData[0].F89904!== undefined?this.props.pageData[0].F89904:89904/*"جستجو"*/} onClick={this.onCompareButtonClick} />

                                <select 
                                    id="item2" 
                                    type="text" 
                                    className="Select_Compare"
                                    required="required" 
                                    value={this.state.item2 || ''} 
                                    onChange={this.onText2Change}
                                    onKeyPress={this.onText2KeyPress}
                                >  
                                    {   
                                        ((this.state.ParagraphSequenceList)&&(this.state.ParagraphSequenceList != null))
                                        ?
                                        (this.state.ParagraphSequenceList.map((ParagraphSequence,i) =>
                                            {
                                                return  (
                                                    (i===0)
                                                    ?
                                                    (
                                                        //[
                                                        //  <option key={ParagraphSequence.Code+"-1"} value={"All"} select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F89902!== undefined?this.props.pageData[0].F89902:89902/*همه*/}</option>
                                                            //,
                                                            <option key={ParagraphSequence.Code} value={ParagraphSequence.Code}>{ParagraphSequence.Title}</option> 
                                                        //]
                                                    )
                                                    :
                                                    (
                                                        <option key={ParagraphSequence.Code} value={ParagraphSequence.Code}>{ParagraphSequence.Title}</option> 
                                                    )
                                                )
                                            })
                                        )
                                        :
                                        <option value="-1">-</option>       
                                    }                
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                ,
                (this.state.ParagraphList && this.state.ParagraphList.length>0)
                ?
                <PerSurfCompareParagraphList    ParagraphList={this.state.ParagraphList}
                                                pageData={this.props.pageData}
                />
                :
                <EmptyDiv />
                ,
                <Loading loadingShow={this.state.loadingShow} />
            ]
        );
    }
}

export default PerSurfVersionCompareSelectBar;